// src/lib/kbeanApi/getUserProfileByToken.js
// Filepath: // src/lib/kbeanApi/getUserProfileByToken.js

import { requestJson } from "../http/request";
import { ApiError } from "../http/errors";

/**
 * Calls the "Get Kbean User Profile by Token" endpoint.
 * Uses REACT_APP_GET_KBEAN_USER_PROFILE_BY_TOKEN_URL as the URL.
 *
 * This endpoint is a GET that relies on Authorization: Bearer <token>.
 * Returns the raw JSON profile (no normalization yet).
 */

/**
 * @typedef {Object} KbeanUserProfile
 * @property {string} id
 * @property {number} followingCount
 * @property {number} followedCount
 * @property {any} profileImageData
 * @property {string} userName
 * @property {string} emailAddress
 * @property {string|null} phoneNumber
 * @property {string|null} firstName
 * @property {string|null} lastName
 * @property {string} fullName
 * @property {string|null} profilePicture
 * @property {number} accountBalance
 * @property {Object} socialMedia
 * @property {string|null} biography
 * @property {boolean} allowMatureContent
 * @property {boolean} isKbeanSelect
 * @property {boolean} isPopularArtist
 * @property {boolean} hasSignedUpWithNflight
 * @property {boolean} hasSignedUpWithINSSA
 * @property {Array<{ lovedArtworkId: string, created: string }>} lovedArtworks
 * @property {Array<any>} superCoinAward
 * @property {Array<string>} artSalesBasket
 * @property {Array<any>} connectedDevices
 * @property {Array<any>} fcmDevices
 * @property {Array<string>} following
 * @property {Array<{ id: string, collectionName: string, ownedArtworks: string[] }>} collections
 * @property {number} superCoinsBalance
 * @property {Array<any>} superCoinsHistoryTransactions
 * @property {string} payerId
 * @property {string} sellerLoyaltyStatus
 * @property {number} aggregatedSales
 */

/**
 * @returns {Promise<KbeanUserProfile>} Raw user profile JSON
 */
export async function getUserProfileByToken() {
  const url = process.env.REACT_APP_GET_KBEAN_USER_PROFILE_BY_TOKEN_URL;
  if (!url) {
    throw new ApiError("Missing env REACT_APP_GET_KBEAN_USER_PROFILE_BY_TOKEN_URL");
  }

  return requestJson(url, {
    method: "GET",
    withAuth: true,
    timeoutMs: 15000,
  });
}
